module.exports = __webpack_public_path__ + "static/media/mainnet.983a5f1b.svg";